import { Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import Layout from './components/Layout';
import Home from './pages/Home';
import ServiceDetail from './pages/ServiceDetail';
import GalleryPage from './pages/GalleryPage';
import About from './pages/About';
import Contact from './pages/Contact';
import Careers from './pages/Careers';

export default function App() {
  return (
    <HelmetProvider>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/galleri" element={<GalleryPage />} />
          <Route path="/om-os" element={<About />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/ledige-stillinger" element={<Careers />} />
          <Route path="/:slug" element={<ServiceDetail />} />
        </Routes>
      </Layout>
    </HelmetProvider>
  );
}
